import { useNavigate, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useAppDispatch, useAppSelector } from 'stores/hooks';
import {
  getAuthStatus,
  checkAuthAsync,
  AUTH_STATUSES,
  signInProviderAsync,
} from 'stores/auth/authSlice';

import usePrevious from 'hooks/usePrevious';

const LOGIN_ROUTES = [
  '/sign-in',
  '/sign-up',
  '/init',
];

export default function CheckUserAuth() {
  const authStatus = useAppSelector(getAuthStatus);
  const dispatch = useAppDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const prevAuthStatus = usePrevious(authStatus);
  const {
    logout,
    isAuthenticated: auth0IsAuthenticated,
    getAccessTokenSilently,
  } = useAuth0();

  const isOnLoginPage = LOGIN_ROUTES.includes(location.pathname);
  const [urlToRedirect, setUrlToRedirect] = useState('/');

  // Auth0 connection
  useEffect(() => {
    if (auth0IsAuthenticated) {
      getAccessTokenSilently().then((token) => {
        dispatch(signInProviderAsync({
          provider: 'auth0',
          clientId: process.env.REACT_APP_AUTH0_CLIENT_ID || '',
          accessToken: token,
        }));
      });
    }
  }, [dispatch, getAccessTokenSilently, auth0IsAuthenticated]);

  useEffect(() => {
    // FIX for: useNavigate causes waste rendering
    // https://github.com/remix-run/react-router/issues/7634
    if (authStatus === prevAuthStatus) {
      return;
    }
    if (authStatus === AUTH_STATUSES.NOT_CHECKED) {
      dispatch(checkAuthAsync());
    }
    if (authStatus === AUTH_STATUSES.NOT_LOGGED && !isOnLoginPage) {
      logout({ logoutParams: { returnTo: `${window.location.origin}/sign-in` } });
      navigate('/sign-in', { replace: true });
    }
    if (authStatus === AUTH_STATUSES.LOGGED_OUT) {
      logout({ logoutParams: { returnTo: `${window.location.origin}/sign-in` } });
      setUrlToRedirect('/');
      navigate('/sign-in', { replace: true });
    }
    if (authStatus === AUTH_STATUSES.LOGGED && isOnLoginPage) {
      navigate(urlToRedirect, { replace: true });
    }
  }, [
    dispatch,
    setUrlToRedirect,
    navigate,
    urlToRedirect,
    isOnLoginPage,
    authStatus,
    prevAuthStatus,
    logout,
  ]);

  return null;
}
